
























import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Picture } from '@/components/atoms';
import SocialInteractions from '@/componentsV2/organisms/SocialRewards/SocialInteractions.vue';

import FacebookShareIcon from '@/components/icons/social-media/FacebookShare.vue';
import FacebookFollowIcon from '@/components/icons/social-media/FacebookFollow.vue';
import InstagramFollowIcon from '@/components/icons/social-media/InstagramFollow.vue';
import TwitterFollowIcon from '@/components/icons/social-media/TwitterFollow.vue';
import TwitterShareIcon from '@/components/icons/social-media/TwitterShare.vue';
import YouTubeSubscribeIcon from '@/components/icons/social-media/YouTubeSubscribe.vue';
import TikTokFollowIcon from '@/components/icons/social-media/TikTokFollow.vue';
import PinterestFollowIcon from '@/components/icons/social-media/PinterestFollow.vue';
import { ESocialRewards } from '@/views/SocialRewards/SocialRewardsEnum';
import { SocialRewardCampaign } from '@/models/social-rewards';

interface SocialInteractionsProp {
  type: ESocialRewards;
  iconComponent: string;
  title: string;
  description: string;
  campaignData?: SocialRewardCampaign;
}

type CampaignDictionary = { [key in ESocialRewards]?: SocialRewardCampaign };

export const socialList: SocialInteractionsProp[] = [
  {
    type: ESocialRewards.FACEBOOK_SHARE,
    iconComponent: 'FacebookShareIcon',
    title: 'Share on Facebook',
    description: 'Reward members when they share your website on Facebook.'
  },
  {
    type: ESocialRewards.FACEBOOK_LIKE,
    iconComponent: 'FacebookFollowIcon',
    title: 'Like on Facebook',
    description: 'Reward people when they like your Facebook page.'
  },
  {
    type: ESocialRewards.INSTAGRAM_FOLLOW,
    iconComponent: 'InstagramFollowIcon',
    title: 'Follow on Instagram',
    description: 'Reward members when they follow you on Instagram.'
  },
  {
    type: ESocialRewards.TWITTER_FOLLOW,
    iconComponent: 'TwitterFollowIcon',
    title: 'Follow on Twitter',
    description: 'Reward members when they follow your Twitter account.'
  },
  {
    type: ESocialRewards.TWITTER_SHARE,
    iconComponent: 'TwitterShareIcon',
    title: 'Share on Twitter',
    description: 'Reward members when they share your store on Twitter.'
  },
  {
    type: ESocialRewards.YOUTUBE_SUBSCRIBE,
    iconComponent: 'YouTubeSubscribeIcon',
    title: 'Subscribe on YouTube',
    description: 'Reward members when they subscribe to your channel.'
  },
  {
    type: ESocialRewards.TIKTOK_FOLLOW,
    iconComponent: 'TikTokFollowIcon',
    title: 'Follow on TikTok',
    description: 'Reward members when they follow you on TikTok.'
  },
  {
    type: ESocialRewards.PINTEREST_FOLLOW,
    iconComponent: 'PinterestFollowIcon',
    title: 'Follow on Pinterest',
    description: 'Reward members when they follow you on Pinterest.'
  }
];

@Component({
  components: {
    Typography,
    Picture,
    SocialInteractions,
    FacebookShareIcon,
    FacebookFollowIcon,
    InstagramFollowIcon,
    TwitterFollowIcon,
    TwitterShareIcon,
    YouTubeSubscribeIcon,
    TikTokFollowIcon,
    PinterestFollowIcon
  }
})
export default class CampaignList extends Vue {
  @Prop({ default: () => [] })
  readonly socialRewardsCampaigns!: SocialRewardCampaign[];

  socialList = socialList;

  get campaignsData() {
    return this.socialRewardsCampaigns.reduce(
      (acc, campaignData) => ({
        ...acc,
        [campaignData.type]: campaignData
      }),
      {}
    ) as CampaignDictionary;
  }

  gotoOffer(socialName: ESocialRewards, action: 'create' | 'edit') {
    const params = this.$route.params;

    this.$router.push({
      path: `/social-rewards/${socialName}/${action}`,
      ...(params.taskSlug && {
        query: {
          start_guide_task: params.taskSlug
        }
      })
    });
  }

  onStatusChange(event: SocialRewardCampaign) {
    this.$emit('status-changed', event);
  }
}
